import React, { ChangeEventHandler, FocusEventHandler, PropsWithChildren, useEffect, useState } from "react";
import { Controller, FieldValues } from "react-hook-form";
import { InputFLProps, InputFLUncontrolled } from "./InputFL";

export const FormattedInputFL = <T extends FieldValues,>({ children, control, name, formatter, type, onFocus, ...rest }: PropsWithChildren<InputFLProps<T>>) => {   
   return (<Controller
      control={control}
      name={name}
      render={({
         field: { onChange, onBlur, value, name, ref },
         fieldState: { isTouched, isDirty, error },
         formState,
      }) => {         
         const [localValue, setLocalValue] = useState<string>(value);
         const [localType, setLocalType] = useState(type);
         const [isFocused, setIsFocused] = useState(false);

         useEffect(() => {            
            if(!isFocused)
               valueToFormatted(value?.toString());
         }, [value, isFocused])

         const formattedToValue = () => {
            setLocalType(type)
            setLocalValue(value)
         }

         const valueToFormatted = (v: string) => {
            setLocalType("text");                        
            setLocalValue(formatter ? formatter(v) : v);
         }

         const onFocusLocal: FocusEventHandler<HTMLInputElement> = (e) => {
            formattedToValue();
            setIsFocused(true);
            if (onFocus)
               onFocus(e);
         }

         const onBlurLocal = () => {            
            setIsFocused(false);                        
            onBlur()
         }

         const onChangeLocal: ChangeEventHandler<HTMLInputElement> = (e) => {
            setLocalValue(e.currentTarget.value);
            onChange(e);
         }

         return (
            <InputFLUncontrolled
               {...rest}
               isInvalid={!!error}
               validationMessage={error?.message}
               id={name}
               name={name}
               onBlur={onBlurLocal}
               onChange={onChangeLocal}
               onFocus={onFocusLocal}
               value={localValue}
               type={localType}
               innerRef={ref}
            >{children}</InputFLUncontrolled>
         )
      }}
   />)
}